<template>
    <LogInAs :athleteId="athleteId" :athleteName="userFullName">
        <Action icon="sr-2 sr-v2-login" text="Log In as Athlete" />
    </LogInAs>
</template>

<script>
import Action from '../Action'
import LogInAs from '@/components/LogInAs'
import { mapGetters } from 'vuex'

export default {
    components: { Action, LogInAs },

    computed: {
        ...mapGetters('athleteProfile', ['athleteId', 'userFullName']),
    }
}
</script>